import { Validators } from '@angular/forms';
import { Rules } from '../models/Field/FieldBase';

export function mapRulesToValidators(rules: Rules): Rules {
  const result: any = {};

  for (let ruleKey in rules) {
    const ruleDefinition = rules[ruleKey];

    switch (ruleKey) {
      case 'required':
        result.required = {
          validator: Validators.required,
          ...ruleDefinition,
        };
        break;
      case 'requiredTrue':
        result.requiredTrue = {
          validator: Validators.requiredTrue,
          ...ruleDefinition,
        };
        break;
      case 'maxLength':
        result.maxlength = {
          validator: Validators.maxLength(ruleDefinition.value),
          message: 'too long',
          ...ruleDefinition,
        };
        break;
      case 'minLength':
        result.minlength = {
          validator: Validators.minLength(ruleDefinition.value),
          message: 'too short',
          ...ruleDefinition,
        };
        break;
      case 'min':
        result.min = {
          validator: Validators.min(ruleDefinition.value),
          message: 'too small',
          ...ruleDefinition,
        };
        break;
      case 'max':
        result.max = {
          validator: Validators.max(ruleDefinition.value),
          message: 'too high',
          ...ruleDefinition,
        };
        break;
      case 'number':
        result.pattern = {
          validator: Validators.pattern('^[0-9]*$'),
          message: 'not a number',
          ...ruleDefinition,
        };
        break;
      case 'email':
        result.email = {
          validator: Validators.email,
          message: 'not a valid email format',
          ...ruleDefinition,
        };
        break;
    }
  }

  return result;
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/utilities/mapRulesToValidators.ts